<template>
  <div class="m_tab_view">
    <div class="mtv_tabs">
      <div
        v-for="item in tabs"
        :key="item.value"
        class="mtv_tab"
        :class="{ active: item.value === current }"
        @click="onTab(item.value)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="mtv_panels">
      <div v-for="item in tabs" :key="item.value" class="mtv_panel">
        <div :ref="item.value" class="mtvp_anchor"></div>
        <slot name="panel" :panel="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileTabView',
  props: {
    /**
     * label 标签
     * value 值(唯一标识)
     */
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: '',
      tabsOffset: [],
    }
  },
  methods: {
    onTab(value) {
      this.current = value
      this.$refs[value][0].scrollIntoView({
        behavior: 'smooth',
      })
    },
    getOffsetTop(el) {
      return el.offsetParent
        ? el.offsetTop + this.getOffsetTop(el.offsetParent)
        : el.offsetTop
    },
    handlePageScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      for (let tabOffset of this.tabsOffset) {
        if (scrollTop < tabOffset.offset) {
          this.current = tabOffset.value
          return
        }
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handlePageScroll)
    if (this.tabs.length > 0) {
      this.current = this.tabs[0].value
    }
    window.onload = () => {
      this.tabsOffset = this.tabs.map((item) => {
        let el = this.$refs[item.value][0]
        return {
          value: item.value,
          offset: this.getOffsetTop(el) + el.parentNode.offsetHeight - 40,
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handlePageScroll)
  },
}
</script>

<style lang="scss">
.m_tab_view {
  .mtv_tabs {
    display: flex;
    height: 44px;
    padding: 0 20px;
    background: #f7f9fc;
  }
  .mtv_tab {
    position: relative;
    flex: 1 1 100%;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #2a2b31;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      height: 1px;
      width: 15%;
      visibility: hidden;
      background: #0b6fd6;
      transition: 0.3s linear;
    }
  }
  .mtv_tab {
    &.active {
      color: #0b6fd6;
      &:after {
        transform: scaleX(2);
        visibility: visible;
      }
    }
  }
  .mtv_panel {
    position: relative;
    .mtvp_anchor {
      position: absolute;
      top: -48px;
    }
  }
}
</style>
